import {useContext} from 'react'
import {UserContext} from '../context/UserContext'

export const useGetUser = () => {
  const res = useContext(UserContext)
  return {...res}
}
